import { useFastStore } from '../context/FastContext';
export const useError = () => {
  return useFastStore(state => state.error.error);
};